/**
 * The wizard ⇄ embed-loader postMessage contract. The operations booking-widget
 * loader (apps/operations/.../widget/booking-loader.ts) mirrors these messages:
 * it only trusts events whose origin matches the app base it iframed and whose
 * payload carries `source: 'notifi-booking'`.
 */
export const BOOKING_EMBED_SOURCE = 'notifi-booking';

export type BookingEmbedMessage =
  | { source: typeof BOOKING_EMBED_SOURCE; type: 'ready' }
  | { source: typeof BOOKING_EMBED_SOURCE; type: 'close' }
  | {
      source: typeof BOOKING_EMBED_SOURCE;
      type: 'booking-completed';
      referenceNumber: string;
      serviceName: string;
    };

/** True when the wizard runs inside the embed loader's iframe. */
export function isEmbedded(embedSearchFlag: boolean): boolean {
  return embedSearchFlag && typeof window !== 'undefined' && window.parent !== window;
}

/** Post to the embedding host page. targetOrigin stays '*' — messages carry no
 *  secrets and the host origin (any customer site) is unknowable here; the
 *  LOADER side pins origins. */
export function postToHost(message: BookingEmbedMessage): void {
  try {
    window.parent.postMessage(message, '*');
  } catch {
    // Sandboxed/broken parent — the wizard still works standalone.
  }
}
